import { render, staticRenderFns } from "./SavedTasklists.vue?vue&type=template&id=3af42264&scoped=true"
import script from "./SavedTasklists.vue?vue&type=script&lang=js"
export * from "./SavedTasklists.vue?vue&type=script&lang=js"
import style0 from "./SavedTasklists.vue?vue&type=style&index=0&id=3af42264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af42264",
  null
  
)

export default component.exports